import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectMedicalExpenseCFStep, makeSelectMedicalExpenseCFStepErrors } from './selectors';
import { makeSelectInsuredsList, makeSelectIsAppsureInstanceSCTI } from '../../App/selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
  resetFormEuropeanUnionData,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import CurrencySelector from '../components/CurrencySelector';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { ExpenseDescriptionList } from './components/DescriptionOfItem';
import { DynamicDatePickerList } from './components/DynamicDatePicker';

export class MedicalExpenseCFStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
  };

  onDescriptionOfItemsChange = (data) => {
    this.props.onFormDataChange('form.expenseDescriptionOfItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onTreatmentDatesChange = (data) => {
    this.props.onFormDataChange('form.treatmentDates', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) => {
    return array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });
  }

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
    ? reasonsForTripInterruption.toJS()
    : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
    ? reasonsForDelay.toJS()
    : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  renderDescriptionOfItems() {
    const { expenseDescriptionOfItems } = this.props.form;
    const newExpenseDescriptionOfItems = this.appendIds(expenseDescriptionOfItems);
    const { isSummary, submitted, insuredsList, isAppsureInstanceSCTI } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <ExpenseDescriptionList
          data={newExpenseDescriptionOfItems}
          onChange={this.onDescriptionOfItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isAppsureInstanceSCTI={isAppsureInstanceSCTI}
        />
      </div>
    );
  }

  renderTreatmentDates() {
    const { treatmentDates } = this.props.form;
    const treatmentDatesWithIds = this.appendIds(treatmentDates || []);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DynamicDatePickerList
          data={treatmentDatesWithIds}
          onChange={this.onTreatmentDatesChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderHospitalAndMedicalExpenses() {
    const {
      isTheClaimTheResultOfASicknessOrInjury,
      natureOfSickness,
      accidentOfInjury,
      dateNature,
      placeNature,
      wasThereAnyPreviousTreatmentForThisCondition,
      dateSicknessOrInjuryBegan,
      dateFirstTreated,
      nameOfPhysician,
      addressPhysician,
      cityOrTownPhysician,
      countryPhysician,
      zipPhysician,
      phonePhysician,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.illnessOrAccidentStatement} />
            </PageSectionHeader>           
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateSicknessOrInjuryBegan"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateSicknessOrInjuryBegan}
                  fieldName={messages.dateSicknessOrInjuryBegan}
                  >
                  <DatePicker
                    disabled={isReadOnly}
                    type="text"
                    onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBegan')}
                    value={dateSicknessOrInjuryBegan}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateSicknessOrInjuryBegan}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateSicknessOrInjuryBegan}
                  />
                  </ErrorMessage>
                </Validate>
          </div>
          <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateFirstTreated"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateFirstTreated}
                  fieldName={messages.dateFirstTreated}
                  >
                  <DatePicker
                    disabled={isReadOnly}
                    type="text"
                    onDayChange={this.handleDayChange('form.dateFirstTreated')}
                    value={dateFirstTreated}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateFirstTreated}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateFirstTreated}
                  />
                  </ErrorMessage>
                </Validate>
          </div>
          <div className={'col-sm-4 form-group'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.isTheClaimTheResultOfASicknessOrInjury} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Sickness"
                    checked={isTheClaimTheResultOfASicknessOrInjury === 'Sickness'}
                    onChange={this.handleChange('form.isTheClaimTheResultOfASicknessOrInjury')}
                  />
                  <FormattedMessage {...messages.sickness} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Accident"
                    checked={isTheClaimTheResultOfASicknessOrInjury === 'Accident'}
                    onChange={this.handleChange('form.isTheClaimTheResultOfASicknessOrInjury')}
                  />
                  <FormattedMessage {...messages.accident} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {isTheClaimTheResultOfASicknessOrInjury !== '' &&
          <div>
            <div className={'ml-2 row'}>
              {isTheClaimTheResultOfASicknessOrInjury === 'Sickness' &&
              <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="natureOfSickness"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={natureOfSickness}
                    fieldName={messages.natureOfSickness}                  
                    >
                      <Textbox
                        name="natureOfSickness"
                        type="text"
                        onChange={this.handleChange('form.natureOfSickness')}
                        value={natureOfSickness}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.natureOfSickness}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>}
              {isTheClaimTheResultOfASicknessOrInjury === 'Accident' &&
              <div className={'col-sm-8 form-group'}>
                  <Validate
                    name="accidentOfInjury"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={accidentOfInjury}
                    fieldName={messages.nameOfAccident}                  
                    >
                      <Textbox
                        name="accidentOfInjury"
                        type="text"
                        onChange={this.handleChange('form.accidentOfInjury')}
                        value={accidentOfInjury}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.nameOfAccident}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>}
            </div>
            <div className={'ml-2 row'}>
            {isTheClaimTheResultOfASicknessOrInjury === 'Accident' &&
              <div className={'col-sm-4 form-group'}>
                    <Validate
                      name="dateNature"
                      validators={[checkDateOnly, required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={dateNature}
                      fieldName={messages.date}
                      >
                      <DatePicker
                        disabled={isReadOnly}
                        type="text"
                        onDayChange={this.handleDayChange('form.dateNature')}
                        value={dateNature}
                        placeholder="dd/mm/yyyy"
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.date}
                        />
                      </ErrorMessage>
                      <ErrorMessage for="checkDateOnly">
                      <FormattedMessage
                        {...messages.checkEventDate}
                        values={messages.date}
                      />
                      </ErrorMessage>
                    </Validate>
              </div>}
              {isTheClaimTheResultOfASicknessOrInjury === 'Accident' &&
              <div className={'col-sm-8 form-group'}>
                  <Validate
                    name="placeNature"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={placeNature}
                    fieldName={messages.place}                  
                    >
                      <Textbox
                        name="placeNature"
                        type="text"
                        onChange={this.handleChange('form.placeNature')}
                        value={placeNature}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.place}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>}
            </div>
          </div>
        }
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.wasThereAnyPreviousTreatmentForThisCondition} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasThereAnyPreviousTreatmentForThisCondition === 'true'}
                    onChange={this.handleChange('form.wasThereAnyPreviousTreatmentForThisCondition')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasThereAnyPreviousTreatmentForThisCondition === 'false'}
                    onChange={this.handleChange('form.wasThereAnyPreviousTreatmentForThisCondition')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {wasThereAnyPreviousTreatmentForThisCondition === 'true' &&
          <div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="nameOfPhysician"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={nameOfPhysician}
                    fieldName={messages.nameOfPhysician}                  
                    >
                      <Textbox
                        name="nameOfPhysician"
                        type="text"
                        onChange={this.handleChange('form.nameOfPhysician')}
                        value={nameOfPhysician}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.nameOfPhysician}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="addressPhysician"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={addressPhysician}
                    fieldName={messages.address}                  
                    >
                      <Textbox
                        name="addressPhysician"
                        type="text"
                        onChange={this.handleChange('form.addressPhysician')}
                        value={addressPhysician}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.address}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="cityOrTownPhysician"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={cityOrTownPhysician}
                    fieldName={messages.cityOrTown}                  
                    >
                      <Textbox
                        name="cityOrTownPhysician"
                        type="text"
                        onChange={this.handleChange('form.cityOrTownPhysician')}
                        value={cityOrTownPhysician}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.cityOrTown}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                  <Validate
                    name="countryPhysician"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={countryPhysician}
                    fieldName={messages.country}                  
                    >
                      <Textbox
                        name="countryPhysician"
                        type="text"
                        onChange={this.handleChange('form.countryPhysician')}
                        value={countryPhysician}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.country}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                  <Validate
                    name="zipPhysician"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={zipPhysician}
                    fieldName={messages.zip}                  
                    >
                      <Textbox
                        name="zipPhysician"
                        type="number"
                        onChange={this.handleChange('form.zipPhysician')}
                        value={zipPhysician}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.zip}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                  <Validate
                    name="phonePhysician"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={phonePhysician}
                    fieldName={messages.phoneNumber}                  
                    >
                      <Textbox
                        name="phonePhysician"
                        type="number"
                        onChange={this.handleChangePhoneNumber('form.phonePhysician')}
                        value={phonePhysician}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.phoneNumber}
                        />
                      </ErrorMessage>
                    </Validate>
              </div>
            </div>
            {this.renderTreatmentDates()}
          </div>}
        {this.renderDescriptionOfItems()}
      </div>
    );
  }

  render() {
    const {
      doYouHaveAnyOtherTypeOfCoverage,
      insuranceCarriersName,
      address,
      cityOrTown,
      country,
      postalCode,
      policyId,
      typeOfPolicy,
      contact,
      phoneNumber,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div className={'row'}>
          <div className={'col-sm-5 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.doYouHaveAnyOtherTypeOfCoverage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={doYouHaveAnyOtherTypeOfCoverage === 'true'}
                    onChange={this.handleChange('form.doYouHaveAnyOtherTypeOfCoverage')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={doYouHaveAnyOtherTypeOfCoverage === 'false'}
                    onChange={this.handleChange('form.doYouHaveAnyOtherTypeOfCoverage')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
          <div className={'col-sm-7 form-group'}></div>
        </div>
        {doYouHaveAnyOtherTypeOfCoverage === 'true' &&
          <div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.ifYesPleaseProvide} />
                </PageSectionHeader>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="insuranceCarriersName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={insuranceCarriersName}
                  fieldName={messages.insuranceCarriersName}
                >
                  <Textbox
                    name="insuranceCarriersName"
                    type="text"
                    onChange={this.handleChange('form.insuranceCarriersName')}
                    value={insuranceCarriersName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.insuranceCarriersName}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="address"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={address}
                  fieldName={messages.address}
                >
                  <Textbox
                    name="address"
                    type="text"
                    onChange={this.handleChange('form.address')}
                    value={address}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.address}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityOrTown"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityOrTown}
                  fieldName={messages.cityOrTown}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.cityOrTown')}
                    value={cityOrTown}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.cityOrTown}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.country')}
                    value={country}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.country}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalCode"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalCode}
                  fieldName={messages.postalCode}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.postalCode')}
                    value={postalCode}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.postalCode}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="typeOfPolicy"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={typeOfPolicy}
                  fieldName={messages.typeOfPolicy}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="typeOfPolicy"
                      type="text"
                      onChange={this.handleChange('form.typeOfPolicy')}
                      value={typeOfPolicy}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.typeOfPolicy}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="policyId"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={policyId}
                  fieldName={messages.policyId}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.policyId')}
                    value={policyId}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.policyId}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contact"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contact}
                  fieldName={messages.contact}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="contact"
                      type="text"
                      onChange={this.handleChange('form.contact')}
                      value={contact}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contact}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumber"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumber}
                  fieldName={messages.phoneNumber}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="phoneNumber"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumber')}
                      value={phoneNumber}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumber}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
          </div>}
        {this.renderHospitalAndMedicalExpenses()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

MedicalExpenseCFStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormEuropeanUnionData: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  insuredsList: PropTypes.any,
  isAppsureInstanceSCTI: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectMedicalExpenseCFStep(),
  errors: makeSelectMedicalExpenseCFStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isAppsureInstanceSCTI: makeSelectIsAppsureInstanceSCTI(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  onResetFormEuropeanUnionData: () => dispatch(resetFormEuropeanUnionData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'medicalExpenseCFStep', reducer });

export default compose(
  withReducer,
  withConnect
)(MedicalExpenseCFStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/index.js